import { render, staticRenderFns } from "./UnitInfo.vue?vue&type=template&id=6701d6ab&scoped=true&"
import script from "./UnitInfo.vue?vue&type=script&lang=js&"
export * from "./UnitInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6701d6ab",
  null
  
)

export default component.exports